export const GET_ALL_ADVERTISERS = 'GET_ALL_ADVERTISERS';
